"use strict";

/*
* ***********************************Example of Usage***********************************
*
* 1 - Simple usage
*    <CurrencyValue value="10283,90" symbol="€" />
*
*/

var currency = require("app/util/formatter/currency.js");

const CurrencyValue = (props) => {

  var formattedValue = props.value ? currency.currencyMask(props.value + "") : null;
  var valueArray = formattedValue ? formattedValue.split(",") : ["0", "00"];

  var integer = valueArray[0];
  var decimal = valueArray[1];

  return (<span className="value--integer">
            <span className="mr-3">{props.symbol}</span>
            {integer},<span className="value--decimal">{decimal}</span>
        </span>);
};

CurrencyValue.propTypes = {
  value: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  symbol: React.PropTypes.string.isRequired
};

module.exports = CurrencyValue;



// WEBPACK FOOTER //
// ./app/shared/components/List/currency-value.jsx